export default __webpack_public_path__ + "fce61195fc90fb737f95fe441ed2154e.png";